var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState, useEffect } from 'react';
export var useAuth = function () {
    var _a = useState({
        isAuthenticated: false,
        isLoading: true,
        token: null,
        user: null,
    }), authState = _a[0], setAuthState = _a[1];
    var verifyToken = function (tokenToVerify) { return __awaiter(void 0, void 0, void 0, function () {
        var response, data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, fetch('/api/auth/verify', {
                            method: 'GET',
                            headers: {
                                'Authorization': "Bearer ".concat(tokenToVerify),
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    setAuthState({
                        isAuthenticated: true,
                        isLoading: false,
                        token: tokenToVerify,
                        user: data.user,
                    });
                    return [2 /*return*/, true];
                case 3:
                    // Token is invalid, remove it
                    localStorage.removeItem('redaktor_token');
                    setAuthState({
                        isAuthenticated: false,
                        isLoading: false,
                        token: null,
                        user: null,
                    });
                    return [2 /*return*/, false];
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error('Token verification failed:', error_1);
                    localStorage.removeItem('redaktor_token');
                    setAuthState({
                        isAuthenticated: false,
                        isLoading: false,
                        token: null,
                        user: null,
                    });
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var login = function (token, user) {
        localStorage.setItem('redaktor_token', token);
        setAuthState({
            isAuthenticated: true,
            isLoading: false,
            token: token,
            user: user,
        });
    };
    var logout = function () {
        localStorage.removeItem('redaktor_token');
        setAuthState({
            isAuthenticated: false,
            isLoading: false,
            token: null,
            user: null,
        });
    };
    var checkAuth = function () { return __awaiter(void 0, void 0, void 0, function () {
        var storedToken;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    storedToken = localStorage.getItem('redaktor_token');
                    if (!storedToken) return [3 /*break*/, 2];
                    return [4 /*yield*/, verifyToken(storedToken)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    setAuthState(function (prev) { return (__assign(__assign({}, prev), { isLoading: false })); });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        checkAuth();
    }, []);
    return __assign(__assign({}, authState), { login: login, logout: logout, verifyToken: verifyToken, checkAuth: checkAuth });
};
